/**
 * Kept in the accessibility tree, hidden on screen (the usual "visually hidden" pattern). Sizes are
 * strings: in MUI `sx`, a bare 1 means 100%.
 */
export const visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
} as const;
